import { render, staticRenderFns } from "./StepConfirmation.vue?vue&type=template&id=07066c45&scoped=true&"
import script from "./StepConfirmation.vue?vue&type=script&lang=ts&"
export * from "./StepConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07066c45",
  null
  
)

export default component.exports